import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";
import { FallbackEmpty } from "~/components/FallbackEmpty";
import { SearchPageLayout } from "~/components/layout/SearchPageLayout";
import { useFeatureFlags } from "~/hooks/useFeatureFlags";
import { PropertyAddressSearch } from "./-components/PropertyAddressSearch";

export const Route = createFileRoute("/(restricted)/ejendomme/")({
  component: RouteComponent,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("properties");

    const title = i18n.t("properties:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function RouteComponent() {
  const { t } = useTranslation(["properties"]);
  const { flags } = useFeatureFlags();

  if (!flags.PROPERTIES_ENABLED) return <FallbackEmpty />;

  return (
    <SearchPageLayout
      headline={t("properties:title")}
      caption={t("properties:search.caption")}
      mobileDisclaimer={t("properties:search.mobileDisclaimer")}
    >
      <PropertyAddressSearch />
    </SearchPageLayout>
  );
}
